import { FormlyFieldProps } from './form-field-wrapper.component';
import { Directive, QueryList, ViewChildren } from '@angular/core';
import {
  FieldType as CoreFieldType,
  FormlyFieldConfig,
} from '@ngx-formly/core';
import {
  FormFieldComponent,
  FormFieldControlDirective,
} from '@lockton-apps/shared/ui/lui';
import { Subject } from 'rxjs';

@Directive({
  selector: '[locktonAppsFieldType]',
  standalone: false,
})
export abstract class FieldTypeDirective<
  F extends FormlyFieldConfig<FormlyFieldProps>
> extends CoreFieldType<F> {
  @ViewChildren(FormFieldControlDirective) set _controls(
    controls: QueryList<FormFieldControlDirective<any>>
  ) {
    this.attachControl(controls.length === 1 ? controls.first : this);
  }

  stateChanges = new Subject<void>();

  _errorState = false;
  get errorState() {
    const showError = this.options!.showError!(this);
    if (showError !== this._errorState) {
      this._errorState = showError;
      this.stateChanges.next();
    }

    return showError;
  }

  get focused() {
    return !!this.field.focus && !this.disabled;
  }
  get disabled() {
    return !!this.props.disabled;
  }
  get required() {
    return !!this.props.required;
  }
  get value() {
    return this.formControl?.value;
  }
  set value(value) {
    this.formControl?.patchValue(value);
  }
  get ngControl() {
    return this.formControl as any;
  }
  get formField(): FormFieldComponent {
    return (this.field as any)?.['_formField'];
  }
  get empty() {
    return this.value == null || this.value === '';
  }

  private attachControl(control: FormFieldControlDirective<any>) {
    if (this.formField && control !== this.formField.control) {
      this.formField.control = control;
      // temporary fix for https://github.com/angular/material2/issues/6728
      const ngControl = control?.ngControl as any;
      if (ngControl?.valueAccessor?.hasOwnProperty('_formField')) {
        ngControl.valueAccessor['_formField'] = this.formField;
      }
      if (ngControl?.valueAccessor?.hasOwnProperty('_parentFormField')) {
        ngControl.valueAccessor['_parentFormField'] = this.formField;
      }
    }
  }
}
